<template>
  <div class="index-container">
    <!-- 背景模糊元素 -->
    <div class="bg-blur-1">
      <div class="bg-blur-1a"></div>
      <div class="bg-blur-1b"></div>
    </div>
    <div class="bg-blur-2"></div>
    <div class="bg-blur-3"></div>

    <!-- 顶部Header已在layout.vue中，这里只渲染内容区 -->

    <!-- 统计卡片区域 -->
    <div class="stats-row">
      <div class="stat-card" v-for="(item, index) in statsData" :key="index">
        <div class="stat-icon-bg" :style="{ background: item.iconBg }">
          <img :src="item.icon" class="stat-icon" />
        </div>
        <div class="stat-value">{{ item.value }}</div>
        <div class="stat-label">{{ item.label }}</div>
      </div>
    </div>

    <!-- 中间图表区域 -->
    <div class="middle-section">
      <!-- 注册用户数图表 -->
      <div class="chart-card chart-large">
        <div class="chart-title">注册用户数</div>
        <div class="chart-legend">
          <div class="legend-item">
            <img src="/assets/CodeBuddyAssets/733_7557/46.svg" />
            <span>注册用户数</span>
          </div>
        </div>
        <div class="chart-area" ref="registerChart"></div>
      </div>

      <!-- 右侧统计 -->
      <div class="right-stats">
        <div class="right-stat-item" v-for="(item, index) in rightStatsData" :key="index">
          <div class="right-stat-icon" :style="{ background: item.iconBg }">
            <img :src="item.icon" class="right-icon-img" />
          </div>
          <div class="right-stat-info">
            <div class="right-stat-value">{{ item.value }}</div>
            <div class="right-stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部区域 -->
    <div class="bottom-section">
      <!-- 工单趋势分析 -->
      <div class="bottom-card">
        <div class="bottom-header">
          <div class="bottom-title">工单趋势分析</div>
          <div class="bottom-subtitle">
            <span>近30天工单数据统计·同比</span>
            <span class="trend-up">上涨8.5%</span>
          </div>
        </div>
        <div class="time-tabs">
          <div class="time-tab active">近7天</div>
          <div class="time-tab">近30天</div>
          <div class="time-tab">本年</div>
        </div>
        <div class="chart-area-small" ref="workOrderChart"></div>
      </div>

      <!-- 费用收费分布 -->
      <div class="bottom-card">
        <div class="bottom-header">
          <div class="bottom-title">费用收费分布</div>
          <div class="bottom-subtitle right">本月应收¥460,330</div>
        </div>
        <div class="fee-chart-area">
          <div class="fee-donut" ref="feeChart"></div>
          <div class="fee-total">
            <div class="fee-total-value">¥460,330</div>
          </div>
        </div>
        <div class="fee-list">
          <div class="fee-item" v-for="(item, index) in feeData" :key="index">
            <div class="fee-item-left">
              <img :src="item.icon" />
              <span>{{ item.name }}</span>
            </div>
            <div class="fee-item-value">{{ item.value }}</div>
          </div>
        </div>
      </div>

      <!-- 巡检 -->
      <div class="bottom-card">
        <div class="bottom-header">
          <div class="bottom-title">巡检</div>
        </div>
        <div class="inspection-list">
          <div class="inspection-item" v-for="(item, index) in inspectionData" :key="index">
            <div class="inspection-icon">
              <img :src="item.icon" />
            </div>
            <div class="inspection-info">
              <div class="inspection-name">{{ item.name }}</div>
              <div class="inspection-desc">{{ item.desc }}</div>
            </div>
            <div class="inspection-status" :class="item.statusClass">{{ item.status }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Index',
  data() {
    return {
      // Mock数据 - 统计卡片
      statsData: [
        { value: '12', label: '小区数', icon: '/assets/CodeBuddyAssets/733_7557/8.svg', iconBg: '#EBF3FF' },
        { value: '124', label: '投票活动数', icon: '/assets/CodeBuddyAssets/733_7557/43.svg', iconBg: '#F5F2FF' },
        { value: '12', label: '通过数', icon: '/assets/CodeBuddyAssets/733_7557/44.svg', iconBg: '#F0FFF8' },
        { value: '12', label: '不通过数', icon: '/assets/CodeBuddyAssets/733_7557/45.svg', iconBg: '#FFF3F1' }
      ],
      // 右侧统计数据
      rightStatsData: [
        { value: '12', label: '今日注册', icon: '/assets/CodeBuddyAssets/733_7557/51.svg', iconBg: '#EBF3FF' },
        { value: '12', label: '今日登录', icon: '/assets/CodeBuddyAssets/733_7557/52.svg', iconBg: '#F0FFF8' },
        { value: '12', label: '三日新增', icon: '/assets/CodeBuddyAssets/733_7557/53.svg', iconBg: '#F5F2FF' },
        { value: '12', label: '七日新增', icon: '/assets/CodeBuddyAssets/733_7557/55.svg', iconBg: '#FFF3F1' },
        { value: '12', label: '七日活跃', icon: '/assets/CodeBuddyAssets/733_7557/57.svg', iconBg: '#F0FFF8' },
        { value: '12', label: '月活跃', icon: '/assets/CodeBuddyAssets/733_7557/58.svg', iconBg: '#EBF3FF' }
      ],
      // 费用数据
      feeData: [
        { name: '物业费', value: '¥329,450', icon: '/assets/CodeBuddyAssets/733_7557/101.svg' },
        { name: '停车费', value: '¥329,450', icon: '/assets/CodeBuddyAssets/733_7557/102.svg' },
        { name: '水电费', value: '¥329,450', icon: '/assets/CodeBuddyAssets/733_7557/103.svg' }
      ],
      // 巡检数据
      inspectionData: [
        { name: '1号楼电梯A座', desc: '正常运行    今日运行 128次', status: '正常', statusClass: 'status-normal', icon: '/assets/CodeBuddyAssets/733_7557/122.svg' },
        { name: '消防系统', desc: '运行正常    最后巡检 3天前', status: '正常', statusClass: 'status-normal', icon: '/assets/CodeBuddyAssets/733_7557/121.svg' },
        { name: '公共照明', desc: '3盏待更换    已使用 89天', status: '维护中', statusClass: 'status-warning', icon: '/assets/CodeBuddyAssets/733_7557/123.svg' },
        { name: '空调机组', desc: '2号机组故障    待维修', status: '告警', statusClass: 'status-error', icon: '/assets/CodeBuddyAssets/733_7557/124.svg' }
      ]
    }
  },
  mounted() {
    this.initRegisterChart()
    this.initWorkOrderChart()
    this.initFeeChart()
  },
  methods: {
    initRegisterChart() {
      const chart = echarts.init(this.$refs.registerChart)
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'white',
          borderColor: '#DCE6F5',
          borderWidth: 1,
          textStyle: { color: '#1D2129', fontSize: 14 },
          formatter: function(params) {
            return `<div style="font-size:14px;color:#1D2129;margin-bottom:4px;">${params[0].axisValue}</div>
                    <div style="font-size:14px;color:#0E76FF;">value：${params[0].value}</div>`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['03-05', '2026-03-06', '2026-03-07', '2026-03-08', '2026-03-09', '2026-03-10', '2026-03-11'],
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#9CA3AF', fontSize: 12 }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#F3F7FB' } },
          axisLabel: { color: '#9CA3AF', fontSize: 12 }
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: { color: '#0E76FF', width: 2 },
          itemStyle: { color: '#0E76FF', borderWidth: 2, borderColor: '#fff' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(14, 118, 255, 0.2)' },
              { offset: 1, color: 'rgba(14, 118, 255, 0.02)' }
            ])
          }
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', () => chart.resize())
    },
    initWorkOrderChart() {
      const chart = echarts.init(this.$refs.workOrderChart)
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'white',
          borderColor: '#DCE6F5',
          borderWidth: 1,
          textStyle: { color: '#1D2129', fontSize: 14 }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['4月3日', '4月7日', '4月7日', '4月11日', '4月14日', '4月14日'],
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#9CA3AF', fontSize: 12 }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#F3F7FB' } },
          axisLabel: { color: '#9CA3AF', fontSize: 12, formatter: '{value}%' }
        },
        series: [{
          data: [30, 45, 35, 60, 50, 70],
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { color: '#0E76FF', width: 2 },
          itemStyle: { color: '#0E76FF' },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(14, 118, 255, 0.15)' },
              { offset: 1, color: 'rgba(14, 118, 255, 0.01)' }
            ])
          }
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', () => chart.resize())
    },
    initFeeChart() {
      const chart = echarts.init(this.$refs.feeChart)
      const option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'white',
          borderColor: '#DCE6F5',
          borderWidth: 1,
          textStyle: { color: '#1D2129', fontSize: 14 }
        },
        series: [{
          type: 'pie',
          radius: ['60%', '80%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: false,
          label: { show: false },
          emphasis: {
            label: { show: false }
          },
          labelLine: { show: false },
          data: [
            { value: 329450, name: '物业费', itemStyle: { color: '#0E76FF' } },
            { value: 329450, name: '停车费', itemStyle: { color: '#39C7A6' } },
            { value: 329450, name: '水电费', itemStyle: { color: '#F08751' } }
          ]
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', () => chart.resize())
    }
  }
}
</script>

<style scoped>
.index-container {
  width: 100%;
  min-height: calc(100vh - 60px);
  background: #EBF2FA;
  position: relative;
  padding: 0px;
  box-sizing: border-box;
}

/* 背景模糊元素 */
.bg-blur-1 {
  width: 604.70px;
  height: 407.85px;
  position: fixed;
  left: -57.71px;
  top: 680.44px;
  transform: rotate(-31deg);
  transform-origin: top left;
  opacity: 0.50;
  pointer-events: none;
  z-index: 0;
}
.bg-blur-1a {
  width: 92.27px;
  height: 420px;
  position: absolute;
  left: 290.88px;
  top: 190.87px;
  transform: rotate(-61deg);
  transform-origin: top left;
  background: rgba(14, 154.58, 255, 0.51);
  box-shadow: 200px 200px 200px;
  border-radius: 9999px;
  filter: blur(100px);
}
.bg-blur-1b {
  width: 23.07px;
  height: 420px;
  position: absolute;
  left: 15.86px;
  top: 334.85px;
  transform: rotate(-62deg);
  transform-origin: top left;
  background: #0EC3FF;
  box-shadow: 135.1999969482422px 135.1999969482422px 135.1999969482422px;
  border-radius: 9999px;
  filter: blur(67.60px);
}
.bg-blur-2 {
  width: 604.70px;
  height: 407.85px;
  position: fixed;
  left: 1189px;
  top: -69.35px;
  opacity: 0.80;
  pointer-events: none;
  z-index: 0;
}
.bg-blur-3 {
  width: 452px;
  height: 452px;
  position: fixed;
  left: 1644px;
  top: 369px;
  background: linear-gradient(107deg, rgba(149.45, 230.92, 230.92, 0.20) 0%, rgba(226, 237, 243, 0.16) 100%);
  box-shadow: 123.80000305175781px 123.80000305175781px 123.80000305175781px;
  border-radius: 9999px;
  filter: blur(61.90px);
  pointer-events: none;
  z-index: 0;
}

/* 统计卡片区域 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}
.stat-card {
  flex: 1;
  height: 144px;
  background: white;
  border-radius: 12px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.stat-icon-bg {
  width: 88px;
  height: 88px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 28px;
  top: 28px;
}
.stat-icon {
  width: 40px;
  height: 40px;
}
.stat-value {
  font-size: 40px;
  font-family: 'D-DIN', sans-serif;
  font-weight: 700;
  color: #1D2129;
  margin-left: 120px;
}
.stat-label {
  font-size: 16px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  color: #8C9BB4;
  margin-left: 120px;
  margin-top: 8px;
}

/* 中间区域 */
.middle-section {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}
.chart-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
}
.chart-large {
  flex: 2;
  height: 444px;
}
.chart-title {
  font-size: 16px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 16px;
}
.chart-legend {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #8C9BB4;
}
.chart-area {
  width: 100%;
  height: calc(100% - 80px);
}

/* 右侧统计 */
.right-stats {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 16px;
}
.right-stat-item {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.right-stat-icon {
  width: 72px;
  height: 72px;
  border-radius: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.right-icon-img {
  width: 36px;
  height: 36px;
}
.right-stat-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.right-stat-value {
  font-size: 36px;
  font-family: 'D-DIN', sans-serif;
  font-weight: 700;
  color: #1D2129;
}
.right-stat-label {
  font-size: 14px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  color: #8C9BB4;
}

/* 底部区域 */
.bottom-section {
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 1;
}
.bottom-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 24px;
  height: 444px;
}
.bottom-header {
  margin-bottom: 16px;
}
.bottom-title {
  font-size: 16px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 8px;
}
.bottom-subtitle {
  font-size: 14px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  color: #8C9BB4;
}
.bottom-subtitle.right {
  text-align: right;
  margin-top: -24px;
}
.trend-up {
  color: #21B956;
  margin-left: 8px;
}

/* 时间标签 */
.time-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}
.time-tab {
  width: 68px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 14px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
  cursor: pointer;
  background: #E3EFFE;
  color: #1D2129;
}
.time-tab.active {
  background: #0E76FF;
  color: white;
}

/* 图表区域 */
.chart-area-small {
  width: 100%;
  height: calc(100% - 120px);
}

/* 费用图表 */
.fee-chart-area {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 20px auto;
}
.fee-donut {
  width: 100%;
  height: 100%;
}
.fee-total {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.fee-total-value {
  font-size: 20px;
  font-family: 'D-DIN', sans-serif;
  font-weight: 700;
  color: #1D2129;
}

/* 费用列表 */
.fee-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.fee-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: #F3F7FB;
  border-radius: 8px;
}
.fee-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #8C9BB4;
}
.fee-item-value {
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  color: #101828;
}

/* 巡检列表 */
.inspection-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.inspection-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #DCE6F5;
  border-radius: 8px;
  gap: 16px;
}
.inspection-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.inspection-icon img {
  width: 32px;
  height: 32px;
}
.inspection-info {
  flex: 1;
}
.inspection-name {
  font-size: 16px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 4px;
}
.inspection-desc {
  font-size: 14px;
  color: #8C9BB4;
}
.inspection-status {
  width: 52px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 14px;
  flex-shrink: 0;
}
.status-normal {
  background: rgba(33, 185, 86, 0.10);
  color: #21B956;
  border: 1px solid #21B956;
}
.status-warning {
  width: 66px;
  background: rgba(255, 140.25, 0, 0.10);
  color: #FF6900;
  border: 1px solid #FF8C00;
}
.status-error {
  background: rgba(251, 44, 54, 0.10);
  color: #FB2C36;
  border: 1px solid #F53C3C;
}
</style>
